
import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/shared/search_form';
import '~/app/assets/javascripts/application/shared/lead';
